import feathersClient from "../../feathers-client";
import head from 'lodash/head';
import last from 'lodash/last';
import { translateBandIntoNumeric } from '@/helpers/translateBand';
import moment from 'moment';
import get from 'lodash/get';

const defaultSavedTemplatePagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultSavedTemplateFilter = {
	$skip:defaultSavedTemplatePagination.$skip,
	$limit: defaultSavedTemplatePagination.$limit
};

export default {
	namespaced:true,
	state:{
		isAddingPerson:true,
		totalShiftPlans:null,
		jobdata:null,
		showData:null,
		saveAsTemplate:false,
		createData:null,
		savedTemplate:[],
		savedTemplatePagination:defaultSavedTemplatePagination,
		savedTemplateFilter:defaultSavedTemplateFilter,
	},
	getters:{
		currentSavedTemplatePage:(state) => {
			const {$limit, $skip} = state.savedTemplatePagination;
			return $skip / $limit + 1;
		},
	},
	mutations:{
		SET_IS_ADDING:(state,data) => {state.isAddingPerson = data},
		SET_TOTAL_SHIFT_PLAN:(state,data) => {state.totalShiftPlans = data},
		SET_JOB_DATA:(state,data) => {state.jobdata = data},
		SET_SHOW_JOB_DATA:(state,data) => {state.showData = data},
		SET_CREATE_JOB_DATA:(state,data) => {state.createData = data},
		SET_SAVE_AS_TEMPLATE:(state,data) => {state.saveAsTemplate = data},
		SET_SAVED_TEMPLATE:(state,data) => {state.savedTemplate = data},
		SET_SAVED_PAGINATION:(state,data) => {state.savedTemplatePagination = {...state.savedTemplatePagination,...data}},
		SET_SAVED_PAGINATION_FILTER:(state,data) => {state.savedTemplateFilter = {...state.savedTemplateFilter,...data}},
	},
	actions:{
		setTheListPage:({commit,state}, page) =>{
			const $skip = (page - 1) * state.savedTemplatePagination.$limit;
			commit('SET_SAVED_PAGINATION', { $skip });
			commit('SET_SAVED_PAGINATION_FILTER', { $skip });
		},
		handlePlanData: async({rootGetters, rootState , state,commit}) => {
			var createData = {}
			const {area,carespecial,shiftTimes} = rootState.jobPostingStore
			const shiftPostData = {
				careLocationId: area.length > 0 ? area[0].id : '',
				area:carespecial?.length > 0 ? carespecial[0].title: '',
			}
			const plans = shiftTimes.map((shiftTime) => {
                const { date, shift } = shiftTime;
                return {
                    ...shiftPostData,
					shift:shift._id ? shift._id : shift,
                    shiftTime:shift,
					date,
                };
            });

			if(state.isAddingPerson || state.saveAsTemplate){
				createData.jobPostData=state.jobdata?.jobs
			}
				createData.shiftPlanData=plans
			if(state.isAddingPerson && !state.saveAsTemplate){
				const results = await feathersClient.service('/api/v3/shiftplans').create(createData,{
					query:{
						$role:rootGetters.currentUserRole
					}
				})
				commit('SET_JOB_DATA',null)
			} else if(state.saveAsTemplate){
				commit('SET_CREATE_JOB_DATA',createData)
			}

		},
		handleJobData: async({state,rootGetters,rootState,dispatch,commit}) => {
			var allData;
			const {area,role,carespecial,duration,fulfilment,location,shiftTimes,healthRosterShiftId,comment} = rootState.jobPostingStore
			const {selectedTemplate} = rootState.jobPostingStore
			if(state.isAddingPerson){
				var fromL; var toL;
				const {band} = rootState.jobPostingStore
				if(band.length > 1){
					const from = translateBandIntoNumeric(get(head(band), 'title'));
					const to = translateBandIntoNumeric(get(last(band), 'title'));
					fromL =  from
					toL = to
				} else {
					const from = translateBandIntoNumeric(get(head(band), 'title'));
					const to = from
					fromL =  from
					toL = to
				}
				var urgentLocal;var autofillLocal
				const autofillValues = {
					'Autofill in 2 days': 2,
					'Autofill in 3 days': 3,
					'Autofill in 4 days': 4,
				};
				autofillLocal = autofillValues[fulfilment];
				urgentLocal = fulfilment === 'Urgently';
				const commonData = {
					managerId: rootGetters.account?._id,
					currentDate: moment().format(),
					careLocation:location,
					careLocationId: area.length > 0 ? area[0].id : '',
					departmentId:area.length > 0 ? area[0].id : '',
					autofill:autofillLocal,
					grade:{from:fromL,to:toL} ,
					area:carespecial?.length > 0 ? carespecial[0].title: '',
					jobTemplateId:selectedTemplate._id,
					title:role?.length > 0 ? role[0].title : '',
					rate: {
						start: 20,
						limit: 30,
						allowAutoIncrease: false,
						current: 20,
					},
					rotaShiftId:healthRosterShiftId,
					fulfillment:(fulfilment != 'Urgently' && fulfilment != 'Manually' ) ? 'Autofill' : fulfilment,
					comments:comment
				}
				const showDataobj = {
					grade:{from:fromL,to:toL},
					persona:selectedTemplate,
					title:role?.length > 0 ? role[0].title : '',
					
				}
				var setShowData;
				if(state.showData?.length > 0){
					const add = [showDataobj]
					setShowData = [...state.showData, ...[showDataobj]];
				} else {
					setShowData = [showDataobj]
				}
				commit('SET_SHOW_JOB_DATA',setShowData)
				const jobs = shiftTimes?.map((shiftTime) => {
					const { date, shift } = shiftTime;
					return {
						...commonData,
						shift:shift._id ? shift._id : shift,
                   		shiftTime:shift,
						date,
						};
				});
				const jobPostData = {
					person: jobs,
				};
				// jobData: jobs,
				const jobWithSkills = await dispatch('jobPostingStore/createJobSkills','',{root:true});
				// eslint-disable-next-line no-plusplus
				for (let j = 0; j < jobPostData?.person?.length; j++) {
					jobPostData.person[j].jobSkills = jobWithSkills;
				}
				if(state.jobdata?.jobs?.length > 0){
					allData = [...state.jobdata?.jobs, ...jobPostData?.person];
				} else {
					allData = jobPostData?.person
				}
				const data = {
					jobs:allData
				}
				commit('SET_JOB_DATA',data)
			}
		},
		getShitPlanById: async({state,rootGetters},id) => {
			return await feathersClient.service('/api/v3/shiftplans').get(id)
		},
		handleJobCreateData: async({state,rootGetters},id) =>{
			const url = '/api/v3/jobs';
			var jobData = state.jobdata.jobs
			var jobWithPlan = state.jobdata.jobs?.map(item => item.shiftPlanId = id)
			const jobPostData = {
				jobData:state.jobdata.jobs
			}
			
			const results = await feathersClient.service(url).create(jobPostData,
				{ query:
					{
					$role: rootGetters.currentUserRole
					}
				});
			return results;
		},
		savePlanAsTemplate: async({state,rootGetters,rootState},name) => {
			const {createData} = state
			const obj = {
				name:name,
				jobs:createData.jobPostData,
				planner:createData.shiftPlanData
			}
			const results = await feathersClient.service('/api/v3/planner-templates').create(obj,{
				query:
					{
					$role: rootGetters.currentUserRole
					}
			});
			return results

		},
		getSavedPlanAsTemplate: async({rootGetters,state,commit}) => {
			const results = await feathersClient.service('/api/v3/planner-templates').find({
				query:{
					// $role: rootGetters.currentUserRole,
					$select:['name']
				}
			});
			commit('SET_SAVED_TEMPLATE',results.data)
			commit('SET_SAVED_PAGINATION',{total:results.total})
			return results
		},
		getSavedPlanAsTemplateById: async({},id) => {
			return await feathersClient.service('/api/v3/planner-templates').get(id)
		}
	}
}
